var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"mini-loader",attrs:{"src":require('@/assets/images/loader.gif')}})
}
var staticRenderFns = []

export { render, staticRenderFns }